import React from "react";
import VopHeader from "components/vop_header";
import HomeHeader from "components/HomeHeader";
import VopFooter from "components/vop_footer";
import SearchContent from "components/SearchContent";
import './style.scss';

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bgColor: 'transparent',
      headerData: { bgColor: "linear-gradient(180deg, rgba(7,7,7,1) 0%,rgba(3,3,3,0) 100%)"}
    }
  }
  componentDidMount() {
    document.title = '京东VOP开放平台-搜索';
  }
  render() {
    return (
      <React.Fragment>
        <div className="search-page">
          <div className="header-wrapper">
            <VopHeader contentWidth="1200px">
                <HomeHeader textStyle={{color: "#fff",fontWeight: "bold"}}/>
            </VopHeader>
          </div>
          <div className="vop_searchpage-wrapper">
            <SearchContent></SearchContent>
          </div>
          <div className="footer-wrapper">
            <VopFooter />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Search;
